var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Schema, type, MapSchema, ArraySchema } from "@colyseus/schema";
import { ArenaPlayer } from "./ArenaPlayer.js";
import { Coin } from "./Coin.js";
/**
 * Authoritative state for an ArenaRoom (Coin Arena mini-game).
 *
 * `status` lifecycle: "lobby" → "live" → "ended".
 * `timeLeft` is seconds remaining in the live phase, server-decremented.
 * `winnerId` is the Colyseus sessionId of the winner (UI-facing — used by
 *   ArenaHud to highlight rows and pick the "You win!" banner). Empty if
 *   no one ever joined.
 * `winnerPubkey` is the WINNER'S WALLET (base58); empty when the winning
 *   client never attested a wallet (guest). The host runner uses this to
 *   call `submit_result` on chain — sessionId is meaningless on-chain.
 * `stateHash` is a deterministic SHA-256 of final results, set on end.
 * `launchId` is the launch slug the creating runner declared (sealed into
 *   its signed onCreate envelope and surfaced to clients so spectators /
 *   leaderboards can filter per-launch). Empty for single-launch / dev.
 */
export class ArenaState extends Schema {
    constructor() {
        super(...arguments);
        this.players = new MapSchema();
        this.coins = new ArraySchema();
        this.timeLeft = 0;
        this.status = "lobby";
        this.winnerId = "";
        this.winnerPubkey = "";
        this.stateHash = "";
        this.launchId = "";
    }
}
__decorate([
    type({ map: ArenaPlayer })
], ArenaState.prototype, "players", void 0);
__decorate([
    type([Coin])
], ArenaState.prototype, "coins", void 0);
__decorate([
    type("number")
], ArenaState.prototype, "timeLeft", void 0);
__decorate([
    type("string")
], ArenaState.prototype, "status", void 0);
__decorate([
    type("string")
], ArenaState.prototype, "winnerId", void 0);
__decorate([
    type("string")
], ArenaState.prototype, "winnerPubkey", void 0);
__decorate([
    type("string")
], ArenaState.prototype, "stateHash", void 0);
__decorate([
    type("string")
], ArenaState.prototype, "launchId", void 0);
//# sourceMappingURL=ArenaState.js.map